import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ColorsForm.css';
import ColorItem from '../ColorItem/ColorItem';
import arrowUp from '../../../../shared/assets/images/up-arrow-angle.svg';
// import arrowDown from '../../../../shared/assets/images/down-arrow-angle.svg';

class ColorsForm extends React.Component {
  static propTypes = {
    selectColor: PropTypes.func,
    selectedColors: PropTypes.arrayOf(PropTypes.shape()),
    colors: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };
  static defaultProps = {
    selectColor: f => f,
    selectedColors: [],
  };

  state = {
    collapsed: true,
  };

  toggleCollapse = () => {
    this.setState(({ collapsed }) => ({ collapsed: !collapsed }));
  };

  render() {
    const { colors, selectedColors, selectColor } = this.props;
    const { collapsed } = this.state;

    const updatedColors = selectedColors.map(item => parseInt(item, 10)) || [];

    const classname = cx(s.root, {
      [s.collapsed]: collapsed,
    });

    return (
      <div className={classname}>
        {colors &&
          colors.map(item =>
            <ColorItem
              key={item.id}
              color={item}
              isActive={updatedColors.includes(parseInt(item.id, 10))}
              selectColor={selectColor}
            />,
          )}
        <div className={s.arrow} onClick={this.toggleCollapse}>
          <img src={arrowUp} width={14} alt="" />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ColorsForm);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/ColorsForm/ColorsForm.js